module.exports = __webpack_public_path__ + "static/media/user.b4ea0b00.svg";